import { adminFetch } from "./_client";
import type { RiskScoreResult } from "./types";

export function fetchRiskScore(token: string, entityType: "user" | "trip" | "review" | "listing", entityId: string | number) {
  return adminFetch<RiskScoreResult>(`/admin/risk-score/${entityType}/${encodeURIComponent(String(entityId))}`, token);
}
